var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1321 4784 c-169 -45 -301 -180 -346 -351 -23 -86 -23 -3660 0 -3746 45 -173 178 -307 350 -352 52 -13 211 -15 1235 -15 1024 0 1183 2 1235 15 172 45 305 179 350 352 23 86 23 3660 0 3746 -45 173 -178 307 -350 352 -86 22 -2391 22 -2474 -1z m2445 -330 c60 -44 69 -67 72 -185 l4 -109 -1281 0 -1281 0 0 94 c0 102 9 137 43 175 49 53 -5 51 1249 48 1161 -2 1167 -2 1194 -23z m74 -1894 l0 -1280 -1280 0 -1280 0 0 1280 0 1280 1280 0 1280 0 0 -1280z m-2 -1708 c-3 -102 -5 -111 -32 -146 -53 -71 28 -67 -1260 -64 -1159 3 -1165 3 -1192 24 -60 44 -69 67 -72 185 l-4 109 1282 0 1282 0 -4 -108z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.cc7e4fcdaa0c99ab34a9ef9e196bd594.svg";
export { ForwardRef as ReactComponent };